var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.737 7.853a11.783 11.783 0 0 1 3.25 8.714c-.308 6.448-5.71 11.44-12.045 11.127-.18-.009-.356-.037-.535-.054l1.285 1.384c.797.856.298 2.444-.298 2.976l-4.086-4.387-1.644-1.766 1.686-1.507 4.648-4.149c.547.59.901 2.318.036 3.091l-1.49 1.363c.18.021.36.046.54.055 4.713.233 8.733-3.48 8.962-8.279a8.77 8.77 0 0 0-2.528-6.597zM16.606 0l4.086 4.387 1.644 1.766-1.686 1.506-4.647 4.149c-.548-.588-.901-2.318-.036-3.09l1.488-1.363c-.18-.021-.358-.046-.54-.055-4.711-.233-8.732 3.48-8.96 8.278a8.768 8.768 0 0 0 2.528 6.598l-2.22 1.972a11.785 11.785 0 0 1-3.25-8.715c.308-6.45 5.712-11.441 12.046-11.127.18.009.355.036.534.054l-1.285-1.385c-.796-.856-.297-2.444.298-2.975z",
    fill: "#262626",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionUpdate);
export default __webpack_public_path__ + "static/media/navigation-and-action-update.2e9aac02.svg";
export { ForwardRef as ReactComponent };